import React, { useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";

// NOTE: This is a placeholder blog system. Replace with actual content and images when ready.
const BlogPostPage = () => {
  const { id } = useParams();

  const [blogs] = useState([
    {
      id: 1,
      title: "The Importance of Professional Facility Maintenance",
      excerpt: "Discover how regular facility maintenance can extend the lifespan of your equipment and reduce operational costs.",
      content: `Proper facility maintenance is crucial for ensuring a safe, efficient, and productive work environment. At Aerolines Engineering & Construction, we understand that your facility is an investment that needs to be protected and optimized.

## Why Facility Maintenance Matters

Regular maintenance prevents equipment failures, extends asset lifespan, and reduces emergency repair costs. A well-maintained facility also improves safety standards and employee productivity.

## Key Benefits of Professional Maintenance

1. **Extended Equipment Lifespan**: Regular servicing and repairs can significantly extend the life of your equipment.
2. **Reduced Downtime**: Preventive maintenance prevents unexpected breakdowns that disrupt operations.
3. **Cost Savings**: Maintenance is cheaper than replacement, ensuring better ROI.
4. **Safety Compliance**: Regular inspections ensure all systems meet safety standards.
5. **Improved Efficiency**: Well-maintained systems operate at peak performance.

## Our Maintenance Services

We offer comprehensive maintenance solutions including:
- HVAC system maintenance
- Plumbing and water system maintenance
- Electrical system inspections
- Equipment servicing
- Safety compliance audits

Contact us today to schedule a facility maintenance consultation.`,
      author: "Aerolines Team",
      date: "February 10, 2026",
      category: "Facility Maintenance",
      image: "https://via.placeholder.com/800x400?text=Facility+Maintenance",
    },
    {
      id: 2,
      title: "Automated Testing Equipment: Enhancing Quality Control",
      excerpt: "Learn how automated testing equipment improves product quality and increases production efficiency.",
      content: `Automated testing equipment plays a vital role in modern manufacturing and quality assurance. It ensures consistency, reduces human error, and accelerates the testing process.

## The Role of Automation in Quality Control

In today's competitive manufacturing environment, quality is not negotiable. Automated testing equipment provides consistent, accurate results that manual testing cannot match.

## Benefits of Automated Testing

- **Higher Accuracy**: Eliminates human error in measurements and checks
- **Faster Testing Cycles**: Reduces time-to-market for products
- **Cost Reduction**: Lower labor costs and reduced waste
- **Scalability**: Handle increased production volumes easily
- **Data Records**: Comprehensive documentation for compliance

## Real-World Applications

Automated testing is used across industries:
- Electronics manufacturing
- Pharmaceutical production
- Food and beverage quality assurance
- Automotive parts validation

Our automated testing solutions are designed to meet industry standards and improve your overall product quality. We customize equipment to match your specific requirements.`,
      author: "Aerolines Team",
      date: "February 5, 2026",
      category: "Automation",
      image: "https://via.placeholder.com/800x400?text=Automated+Testing",
    },
    {
      id: 3,
      title: "Electrical Works: Safety Standards and Best Practices",
      excerpt: "Explore the best practices in electrical engineering to ensure safety and compliance with regulatory standards.",
      content: `Electrical safety is paramount in any industrial or commercial setting. Our team of certified electrical engineers ensures that all installations meet local and international safety standards.

## Electrical Safety Standards

Safety in electrical work is non-negotiable. All electrical installations must comply with:
- IEC standards
- Local building codes
- ISO 9001:2015 quality management systems
- OSHA regulations

## Our Comprehensive Services

1. **Installation**: Professional installation of electrical systems
2. **Maintenance**: Regular inspections and preventive maintenance
3. **Upgrades**: Modernizing outdated electrical infrastructure
4. **Safety Audits**: Comprehensive safety assessments

## Best Practices in Electrical Engineering

- Use high-quality components and materials
- Follow proper grounding and bonding procedures
- Implement regular testing and maintenance schedules
- Train personnel on electrical safety
- Document all work for compliance

Aerolines Engineering & Construction is ISO 9001:2015 certified, ensuring the highest quality standards in all electrical work.`,
      author: "Aerolines Team",
      date: "January 28, 2026",
      category: "Electrical Engineering",
      image: "https://via.placeholder.com/800x400?text=Electrical+Works",
    },
    {
      id: 4,
      title: "PLC Control Systems: Modernizing Industrial Operations",
      excerpt: "Understand how PLC systems can streamline your industrial processes and improve operational efficiency.",
      content: `Programmable Logic Controllers (PLCs) are essential for automating industrial processes. They provide real-time monitoring, precise control, and high reliability.

## What Are PLC Systems?

PLC systems are digital computers used for automation of industrial processes. They monitor inputs, make decisions based on programmed logic, and control outputs.

## Advantages of PLC Control

- **Real-time Processing**: Instant response to changing conditions
- **Reliability**: Built to withstand harsh industrial environments
- **Flexibility**: Easily reprogrammed for different applications
- **Scalability**: Can be expanded as operations grow
- **Cost Efficiency**: Reduces manual labor and increases productivity

## Applications

PLCs are used in:
- Manufacturing automation
- Building management systems
- Water treatment facilities
- Power generation systems
- Transportation systems

Our PLC solutions are customized to optimize your production workflow and reduce downtime. We provide complete system design, installation, and training.`,
      author: "Aerolines Team",
      date: "January 20, 2026",
      category: "Control Systems",
      image: "https://via.placeholder.com/800x400?text=PLC+Systems",
    },
    {
      id: 5,
      title: "Civil Engineering Projects: Case Studies and Success Stories",
      excerpt: "Review our successful civil engineering projects and learn about our expertise in construction and infrastructure.",
      content: `From renovation projects to large-scale construction, Aerolines Engineering & Construction has successfully completed numerous civil engineering projects. Our expertise spans commercial, industrial, and residential sectors.

## Our Project Portfolio

Our successful projects include:
- Office building renovations
- Industrial facility upgrades
- Plumbing and drainage system installations
- Structural repairs and reinforcement
- Building maintenance and restoration

## Quality and Safety Commitment

Our commitment to quality and safety is reflected in:
- ISO 9001:2015 certification
- Safety compliance with all regulations
- Professional project management
- Transparent communication with clients

## Recent Achievements

Aerolines has worked on diverse projects including:
- Ceiling board installations
- Plaster ceiling works
- PVC curtain installations
- Electrical and mechanical works
- Comprehensive facility maintenance

Each project is completed with meticulous attention to detail and adherence to safety standards.`,
      author: "Aerolines Team",
      date: "January 15, 2026",
      category: "Civil Engineering",
      image: "https://via.placeholder.com/800x400?text=Civil+Engineering",
    },
    {
      id: 6,
      title: "Industrial Automation: Reducing Costs and Improving Output",
      excerpt: "Discover how industrial automation can boost your production capacity while reducing operational expenses.",
      content: `Industrial automation integrates various technologies to streamline manufacturing processes. By implementing automated systems, companies experience increased productivity, reduced labor costs, and improved product consistency.

## Why Automate Your Operations?

Industrial automation offers:
- **Increased Output**: Higher production volumes
- **Cost Reduction**: Lower labor and operational costs
- **Quality Improvement**: Consistent product quality
- **Safety**: Fewer workplace injuries
- **Flexibility**: Quick adaptation to market changes

## Technologies Involved

Modern industrial automation includes:
- PLC and SCADA systems
- Robotics and mechanical automation
- Sensors and IoT devices
- Data analytics and monitoring systems
- Integration with ERP systems

## Implementation Strategy

A successful automation project requires:
1. Assessment of current processes
2. Needs analysis and planning
3. System design and customization
4. Installation and commissioning
5. Training and support

Aerolines provides end-to-end automation solutions tailored to your business needs. Contact us to discuss your automation project today.`,
      author: "Aerolines Team",
      date: "January 10, 2026",
      category: "Automation",
      image: "https://via.placeholder.com/800x400?text=Industrial+Automation",
    },
  ]);

  const blog = blogs.find((b) => b.id === parseInt(id));

  if (!blog) {
    return <Navigate to="/blogs" />;
  }

  const relatedBlogs = blogs
    .filter((b) => b.category === blog.category && b.id !== blog.id)
    .slice(0, 3);

  return (
    <div id="blog-post-page">
      {/* Header */}
      <header
        id="blog-post-header"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${blog.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "400px",
          display: "flex",
          alignItems: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        <div className="container" style={{ width: "100%" }}>
          <span
            className="blog-category"
            style={{
              backgroundColor: "#ffcc00",
              color: "#333",
              padding: "10px 20px",
              borderRadius: "20px",
              fontSize: "14px",
              fontWeight: "600",
              textTransform: "uppercase",
              display: "inline-block",
              marginBottom: "20px",
            }}
          >
            {blog.category}
          </span>
          <h1 style={{ fontSize: "48px", fontWeight: "bold", marginBottom: "20px" }}>
            {blog.title}
          </h1>
          <div style={{ fontSize: "16px" }}>
            <span style={{ marginRight: "20px" }}>By {blog.author}</span>
            <span>{blog.date}</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="container" style={{ marginTop: "40px", marginBottom: "40px" }}>
        <div className="row">
          {/* Blog Post Content */}
          <div className="col-md-8 col-md-offset-2">
            <article
              className="blog-post-content"
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                color: "#666",
              }}
            >
              <img
                src={blog.image}
                alt={blog.title}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  marginBottom: "30px",
                }}
              />

              {/* Blog content with markdown-like formatting */}
              {blog.content.split("\n\n").map((paragraph, index) => {
                if (paragraph.startsWith("##")) {
                  return (
                    <h2
                      key={index}
                      style={{
                        fontSize: "28px",
                        fontWeight: "600",
                        color: "#333",
                        marginTop: "30px",
                        marginBottom: "15px",
                      }}
                    >
                      {paragraph.replace("## ", "")}
                    </h2>
                  );
                } else if (paragraph.startsWith("-")) {
                  return (
                    <ul key={index} style={{ marginLeft: "20px", marginBottom: "15px" }}>
                      {paragraph.split("\n").map((item, i) => (
                        <li key={i} style={{ marginBottom: "10px" }}>
                          {item.replace("- ", "")}
                        </li>
                      ))}
                    </ul>
                  );
                } else if (paragraph.match(/^\d+\./)) {
                  return (
                    <ol key={index} style={{ marginLeft: "20px", marginBottom: "15px" }}>
                      {paragraph.split("\n").map((item, i) => (
                        <li key={i} style={{ marginBottom: "10px" }}>
                          {item.replace(/^\d+\.\s*/, "")}
                        </li>
                      ))}
                    </ol>
                  );
                } else {
                  return (
                    <p key={index} style={{ marginBottom: "20px" }}>
                      {paragraph}
                    </p>
                  );
                }
              })}
            </article>

            {/* Call to Action */}
            <div
              style={{
                marginTop: "50px",
                padding: "30px",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <h3 style={{ marginTop: "0" }}>Need Our Services?</h3>
              <p>
                If you're interested in learning more about our {blog.category.toLowerCase()}{" "}
                services, get in touch with us today.
              </p>
              <Link to="/" className="btn btn-custom btn-lg">
                Contact Us
              </Link>
            </div>

            {/* Back to Blog Link */}
            <div style={{ marginTop: "30px", textAlign: "center" }}>
              <Link
                to="/blogs"
                style={{
                  color: "#2196F3",
                  textDecoration: "none",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                ← Back to All Articles
              </Link>
            </div>
          </div>
        </div>

        {/* Related Posts */}
        {relatedBlogs.length > 0 && (
          <div className="row" style={{ marginTop: "60px" }}>
            <div className="col-md-12">
              <h2 style={{ textAlign: "center", marginBottom: "40px" }}>
                Related Articles
              </h2>
            </div>
            {relatedBlogs.map((relatedBlog) => (
              <div key={relatedBlog.id} className="col-md-4 col-sm-6">
                <article className="blog-card">
                  <img
                    src={relatedBlog.image}
                    alt={relatedBlog.title}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px 8px 0 0",
                    }}
                  />
                  <div style={{ padding: "20px" }}>
                    <h3 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>
                      {relatedBlog.title}
                    </h3>
                    <Link
                      to={`/blog/${relatedBlog.id}`}
                      style={{
                        color: "#2196F3",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      Read More →
                    </Link>
                  </div>
                </article>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPostPage;
